import { render, staticRenderFns } from "./status.vue?vue&type=template&id=20582191&scoped=true&"
import script from "./status.vue?vue&type=script&lang=js&"
export * from "./status.vue?vue&type=script&lang=js&"
import style0 from "./status.vue?vue&type=style&index=0&id=20582191&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20582191",
  null
  
)

export default component.exports